import { createRef, Component } from "react";
import PropTypes from "prop-types";
import styles from "./animation.module.less";
import { extract, EventAggregator } from "@parksandresorts/core";
import InteractionHelper from "components/helpers/interaction-helper";
import EventAttributeStore from "components/stores/event-attribute-store";

const MEDIUM_BREAKPOINT = 768;

export default class Animation extends Component {
  static propTypes = {
    animationType: PropTypes.oneOf(["fadeIn", "fadeInLeft", "flipIn"]),
    animationDuration: PropTypes.number,
    /**
     * Delay in miliseconds for when animation should start
     */
    animationDelay: PropTypes.number,
    /**
     * Y offset in pixels for when animation should start
     */
    yAnimationOffset: PropTypes.number,

    /**
     * Y offset in pixels for when animation should start on mobile
     */
    yAnimationOffsetMobile: PropTypes.number,

    /**
     * Boolean value to apply animation when set instead of looking at scroll,
     * can be used together with disable animation on scroll if you want it to be
     * the only triggerpoint for animation
     */

    applyAnimation: PropTypes.bool,

    /**
     * Whether animation component should check for scrolling behaviour
     */
    disableOnScrollCheck: PropTypes.bool,

    /**
     * Extra classes to add to the component
     */
    className: PropTypes.string,
  };

  static defaultProps = {
    yAnimationOffset: 0,
    yAnimationOffsetMobile: 0,
    animationDuration: 300,
    animationType: "fadeIn",
    animationDelay: 0,
    applyAnimation: false,
    disableOnScrollCheck: false,
    className: "",
  };

  constructor(props) {
    super(props);

    this.animationType = extract(props, "animationType");
    this.animationDuration = extract(props, "animationDuration");
    this.animationDelay = extract(props, "animationDelay");
    this.yAnimationOffset = extract(props, "yAnimationOffset");

    this.state = {
      applyAnimation: false,
      animationApplied: false,
    };

    this.ref_animation = createRef();
  }

  componentDidMount() {
    if (!this.props.disableOnScrollCheck) {
      this.onScrollSubcription = EventAggregator.subscribe("onScroll", this.onScroll);
      this.onScroll(0);
    }
  }

  componentWillUnmount() {
    if (this.onScrollSubcription) {
      this.onScrollSubcription.remove();
    }
  }

  onScroll = (yPos) => {
    if (this.isInScreen()) {
      this.setState({
        applyAnimation: true,
      });

      this.onScrollSubcription.remove();
    }
  };

  isInScreen() {
    if (EventAttributeStore.getCurrentWindowWidth() >= MEDIUM_BREAKPOINT) {
      if (this.ref_animation && this.ref_animation.current) {
        return InteractionHelper.isInScreen(this.ref_animation.current, this.yAnimationOffset);
      }
    } else {
      if (this.ref_animation && this.ref_animation.current) {
        return InteractionHelper.isInScreen(this.ref_animation.current, this.yAnimationOffsetMobile);
      }
    }

    return false;
  }

  applyAnimationClass(animationType) {
    switch (animationType) {
      case "fadeIn": {
        return styles.fadeInApply;
      }
      case "fadeInLeft": {
        return styles.fadeInLeftApply;
      }
      case "flipIn": {
        return styles.flipInApply;
      }
      default:
        return "";
    }
  }

  render() {
    const animationStyle = {
      animationDuration: this.animationDuration + "ms",
      animationDelay: this.animationDelay + "ms",
    };

    return (
      <div
        ref={this.ref_animation}
        style={animationStyle}
        className={[
          styles[this.animationType],
          this.state.applyAnimation || this.props.applyAnimation ? this.applyAnimationClass(this.animationType) : "",
          this.props.className,
        ].join(" ")}
      >
        {this.props.children}
      </div>
    );
  }
}
